import { RequestQuery } from '@/buyers/_gen/gql'
import Action from '@/gf/components/Action'
import useToggle from '@/gf/hooks/useToggle'
import useGqlClient from '@/buyers/hooks/useGqlClient'
import EditPartPhaseCodeModal from '@/buyers/components/EditPhaseCodeModal'

const PhaseCodeAction = ({
  rfqPart,
}: {
  rfqPart: RequestQuery['requestForQuotesSearch']['requestForQuotes'][number]['partRequests'][number]
}) => {
  const [open, toggle] = useToggle()
  const client = useGqlClient()
  return (
    <>
      <EditPartPhaseCodeModal
        open={open}
        onClose={toggle.off}
        part={{ partNumber: rfqPart.mpn ?? '', description: rfqPart.description ?? '' }}
        phaseCodeId={rfqPart.phaseCode?.id ?? null}
        partRequestId={rfqPart.id}
        onSuccess={() => client.reFetchObservableQueries()}
      />

      {rfqPart.phaseCode ? (
        <Action.T className="text-sm" onClick={toggle.on}>
          {rfqPart.phaseCode.code}
        </Action.T>
      ) : (
        <Action.T className="text-sm" onClick={toggle.on}>
          Add
        </Action.T>
      )}
    </>
  )
}

export default PhaseCodeAction
